import Effects from './Effects.js';
import Tone from 'tone';
const SIZE=256;
class Oscilloscope extends Effects.Effect {
    constructor(sequencerEngine) {
        super('Oscilloscope', () => new Tone.Analyser({type: 'waveform', size: SIZE}), sequencerEngine); 
        this.size = SIZE;
    }

    getValue() {
        return this.effectNode.getValue();
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        let effect = new Oscilloscope(sequencerEngine);
        return effect;
    }
}

export default Oscilloscope;
